import { render, staticRenderFns } from "./SuperBomComponentList.vue?vue&type=template&id=77fce631&scoped=true"
import script from "./SuperBomComponentList.vue?vue&type=script&lang=js"
export * from "./SuperBomComponentList.vue?vue&type=script&lang=js"
import style0 from "./SuperBomComponentList.vue?vue&type=style&index=0&id=77fce631&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fce631",
  null
  
)

export default component.exports